__turbopack_context__.v({
  "banner": "NotificationBanner-module-scss-module__ozbJrG__banner",
  "content": "NotificationBanner-module-scss-module__ozbJrG__content",
  "slideDown": "NotificationBanner-module-scss-module__ozbJrG__slideDown",
  "wrapper": "NotificationBanner-module-scss-module__ozbJrG__wrapper",
});
